import React, { useState } from 'react'
import { FaFilter } from 'react-icons/fa'
import { HiSortAscending, HiSortDescending } from 'react-icons/hi'

export const SortIcon = ({ value, onClick }) => {
  switch (value) {
    case 1:
      return <HiSortAscending style={{ cursor: 'pointer' }} onClick={onClick} color="blue" size="1.7rem" />
    case -1:
      return <HiSortDescending style={{ cursor: 'pointer' }} onClick={onClick} color="blue" size="1.7rem" />
    default:
      return <HiSortAscending style={{ cursor: 'pointer' }} onClick={onClick} size="1.7rem" />
  }
}

export const FilterIcon = ({ value, onClick }) => {
  //console.log('VALUE : ', value)
  let apply = Array.isArray(value) && value.length > 0 ? true : false
  if (value && apply) {
    return <FaFilter style={{ cursor: 'pointer' }} onClick={onClick} color="blue" />
  }
  return <FaFilter style={{ cursor: 'pointer' }} onClick={onClick} />
}
